import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=2d9a23f7&scoped=true"
import script from "./HistoricalData.vue?vue&type=script&lang=js"
export * from "./HistoricalData.vue?vue&type=script&lang=js"
import style0 from "./HistoricalData.vue?vue&type=style&index=0&id=2d9a23f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a23f7",
  null
  
)

export default component.exports